import React from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Navbar from "@/components/Navbar";
import MobileBottomBar from "@/components/MobileBottomBar";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Database from "@/pages/Database";
import MangaDetail from "@/pages/MangaDetail";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Releases from "@/pages/Releases";
import ReleaseDetail from "@/pages/ReleaseDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Members from "@/pages/Members";
import MemberDetail from "@/pages/MemberDetail";
import Messages from "@/pages/Messages";
import Conversation from "@/pages/Conversation";
import Publishers from "@/pages/Publishers";
import PublisherDetail from "@/pages/PublisherDetail";
import Community from "@/pages/Community";
import TopicDetail from "@/pages/TopicDetail";
import Profile from "@/pages/Profile";
import MyList from "@/pages/MyList";
import MemberMangaList from "@/pages/MemberMangaList";
import Ranking from "@/pages/Ranking";
import HowToEarnPoints from "@/pages/HowToEarnPoints";
import Sorteios, { SorteioDetail } from "@/pages/Sorteios";
import Admin from "@/pages/Admin";
import Notifications from "@/pages/Notifications";
import Explorar from "@/pages/Explorar";
import SeriesPage from "@/pages/SeriesPage";
import SeriesIndex from "@/pages/SeriesIndex";
import { Toaster } from "sonner";
import { useTheme } from "@/context/ThemeContext";
import { api } from "@/lib/api";

function useTrackVisit() {
  React.useEffect(() => {
    try {
      let vid = localStorage.getItem("pm_visitor_id");
      if (!vid) { vid = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("pm_visitor_id", vid); }
      api.post("/track/visit", { visitor_id: vid }).catch(() => {});
    } catch (e) { /* noop */ }
  }, []);
}

function AppRoutes() {
  const location = useLocation();
  useTrackVisit();
  // Handle Google OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <div className="pb-16 md:pb-0">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registar" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/database" element={<Database />} />
        <Route path="/explorar" element={<Explorar />} />
        <Route path="/serie/:slug" element={<SeriesPage />} />
        <Route path="/series" element={<SeriesIndex />} />
        <Route path="/manga/:id" element={<MangaDetail />} />
        <Route path="/noticias" element={<News />} />
        <Route path="/noticias/:id" element={<NewsDetail />} />
        <Route path="/lancamentos" element={<Releases />} />
        <Route path="/lancamentos/:id" element={<ReleaseDetail />} />
        <Route path="/eventos" element={<Events />} />
        <Route path="/eventos/:id" element={<EventDetail />} />
        <Route path="/membros" element={<Members />} />
        <Route path="/membros/:id" element={<MemberDetail />} />
        <Route path="/membros/:id/lista/:type" element={<MemberMangaList />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/ranking/como-ganhar-pontos" element={<HowToEarnPoints />} />
        <Route path="/sorteio" element={<Sorteios />} />
        <Route path="/sorteio/:id" element={<SorteioDetail />} />
        <Route path="/mensagens" element={<Messages />} />
        <Route path="/mensagens/:userId" element={<Conversation />} />
        <Route path="/editoras" element={<Publishers />} />
        <Route path="/editoras/:id" element={<PublisherDetail />} />
        <Route path="/comunidade" element={<Community />} />
        <Route path="/comunidade/:id" element={<TopicDetail />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/perfil/lista/:type" element={<MyList />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/notificacoes" element={<Notifications />} />
      </Routes>
      </div>
      <MobileBottomBar />
    </>
  );
}

function ThemedToaster() {
  const { theme } = useTheme();
  const isLight = theme === "light";
  return (
    <Toaster
      theme={isLight ? "light" : "dark"}
      position="top-right"
      toastOptions={{
        style: isLight
          ? { background: "#FFFFFF", border: "1px solid rgba(0,0,0,0.08)", color: "#18181B" }
          : { background: "#121217", border: "1px solid rgba(255,255,255,0.08)", color: "#FAFAFA" },
      }}
    />
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <AuthProvider>
              <AppRoutes />
              <ThemedToaster />
            </AuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
